
// example
/*
var notifyEl = notification.notifyPopup('Test', 'Dies ist ein Test-Popup.', {
    modal: true,
    show: true,
    showClose: true,
    width: '500px',
    fullscreen: false,
    cssClass: 'loader',
    onClosed: callback,
    buttons: [{
        caption: 'OK',
        callback: notification.close
    }]
});
*/

var notification = {
    name: 'notification',
    transitionDuration: 0.35,

    init: function(onStarted) {
        onStarted();
    },

    // <button type="button" class="close" data-dismiss="modal" aria-label="Close">
    // <span aria-hidden="true">&times;</span>
    // </button>

    notifyPopup: function(title, message, options) {
        options = options || {};
        var notifyEl = $('<div class="modal fade '+(options.cssClass || '')+'" tabindex="-1" role="dialog" data-toggle="modal" style="background-color:rgba(25,25,25,0.4);">'+
            '  <div class="modal-dialog'+(options.fullscreen ? ' fullscreen' : '')+' '+(options.dialogCssClass || '')+'"' +
            ' style="max-width:90%;max-height:calc(100% - 120px);width:'+(options.width || '500px')+';height:'+(options.height || 'auto')+';margin:0px auto;">'+
            '    <div class="modal-content">'+
            '      <div class="modal-header">'+
            '        <h4 class="modal-title">'+(title || '&nbsp;')+'</h4>'+
            '        <div class="toolbar"><div class="btn-group btn-group-1"></div>' +
            '          '+((options.showClose !== false) ? '<div class="btn-group"><button type="button" class="close btn-close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button></div>' : '') +
            '        </div>'+
            '      </div>'+
            '      <div class="modal-body">'+
            '        <span class="message">'+message+'</span>'+
            '      </div>'+
            '      <div class="modal-footer">'+
            '      </div>'+
            '    </div>'+
            '  </div>'+
            '</div>');
        if (options.spinner || false == true) {
            var notifyBody = notifyEl.find('.modal-body');
            notifyBody.addClass('progressing');
            notifyBody.append($('<div class="spinner-container"><i class="fa bi-arrow-repeat fa-spin fa-2x"></i></div>'));
        }
        if ((options.show || true) == true) {
            notification.show(notifyEl);
        }
        $(notifyEl.find('.modal-body')).css({
            overflowY: 'auto',
            maxHeight: notifyEl.outerHeight() - notifyEl.find('.modal-header').outerHeight() - notifyEl.find('.modal-footer').outerHeight()
        });
        if (options.onClosed != null) {
            notifyEl.on('closed', options.onClosed);
        }
        notifyEl.find('.btn-close').on('click', function() {
            notification.close(notifyEl);
        });
        $.each(options.buttons || [], function(i, btn) {
            notification.addButton(notifyEl, btn);
        });
        return notifyEl;
    },

    show: function(notifyEl) {
        $('body').append(notifyEl);
        // notifyEl.modal('show');
        var modalContent = notifyEl.find('.modal-dialog');
        notifyEl.css({'opacity': 1}).show();
        modalContent.css({
            'top': -(modalContent.outerHeight())+'px'
        });
        setTimeout(function() {
            modalContent.css({
                'top': '150px',
                'transition': 'all '+notification.transitionDuration+'s ease-out',
                '-webkit-transition': 'all '+notification.transitionDuration+'s ease-out',
                '-moz-transition': 'all '+notification.transitionDuration+'s ease-out'
            });
        }, 10);
    },

    insertContent: function(notifyEl, content) {
        var notifyBody = notifyEl.find('.modal-body');
        notifyBody.removeClass('progressing').html(content);
    },

    /**
     * @param notifyEl
     * @param buttonOptions {} { caption, callback, cssClass }
     */
    addButton: function(notifyEl, buttonOptions) {
        var btn = $('<button class="btn '+(buttonOptions.cssClass || 'btn-default')+'">'+(buttonOptions.caption || 'Knopf')+'</button>');
        notifyEl.find('.modal-footer').append(btn);
        btn.on('click', function() {
            var result = buttonOptions.callback(notifyEl, btn);
            if (result === true) {
                notification.close(notifyEl);
            }
        });
    },

    close: function(notifyEl, onClosed) {
        notifyEl.find('.modal-dialog').css({
            'top': -notifyEl.outerHeight()+'px',
            'opacity': 0
        });
        // $('body>.modal').modal('hide');
        setTimeout(function() {
            notifyEl.hide().remove();
            $(notifyEl).trigger('closed');
            if (onClosed != null) onClosed();
        }, notification.transitionDuration*1000);
    }

};
window.notification = notification;
